import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import RootLayout from "@/RootLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/admin/AdminRoute";
import HomePage from "@/page";
import RouteErrorBoundary from "@/components/RouteErrorBoundary";
import RouteFallback from "@/components/RouteFallback";

const AboutPage = lazy(() => import("@/about/page"));
const ContactPage = lazy(() => import("@/contact/page"));
const FaqPage = lazy(() => import("@/faq/page"));
const RoadmapPage = lazy(() => import("@/roadmap/page"));
const PrivacyPage = lazy(() => import("@/privacy/page"));
const TermsPage = lazy(() => import("@/terms/page"));
const DpaPage = lazy(() => import("@/dpa/page"));
const SecurityPolicyPage = lazy(() => import("@/security-policy/page"));
const LoginPage = lazy(() => import("@/login/page"));
const SignupPage = lazy(() => import("@/signup/page"));
const ResetPasswordPage = lazy(() => import("@/reset-password/page"));
const SearchPage = lazy(() => import("@/search/page"));
const BookPage = lazy(() => import("@/books/[id]/page.client"));
const ListPage = lazy(() => import("@/lists/[id]/page.client"));
const UserProfilePage = lazy(() => import("@/users/[username]/page.client"));
const SettingsPage = lazy(() => import("@/settings/page"));
const BookClubPage = lazy(() => import("@/book-club/page"));
const SharePage = lazy(() => import("@/share/[bookId]/page.jsx"));
const AdminLayout = lazy(() => import("@/admin/layout"));
const AdminIndexPage = lazy(() => import("@/admin/page"));
const AdminAnalyticsPage = lazy(() => import("@/admin/analytics/page"));
const AdminUsersPage = lazy(() => import("@/admin/users/page"));
const AdminMessagesPage = lazy(() => import("@/admin/messages/page"));
const AdminContentPage = lazy(() => import("@/admin/content/page"));
const AdminMigrationPage = lazy(() => import("@/admin/migration/page"));
const NotFoundPage = lazy(() => import("@/not-found"));

function Sus({ children }) {
  return <Suspense fallback={<RouteFallback />}>{children}</Suspense>;
}

export default function App() {
  return (
    <Routes>
      <Route element={<RootLayout />} errorElement={<RouteErrorBoundary />}>
        <Route index element={<HomePage />} />
        <Route
          path="about"
          element={
            <Sus>
              <AboutPage />
            </Sus>
          }
        />
        <Route
          path="contact"
          element={
            <Sus>
              <ContactPage />
            </Sus>
          }
        />
        <Route
          path="faq"
          element={
            <Sus>
              <FaqPage />
            </Sus>
          }
        />
        <Route
          path="roadmap"
          element={
            <Sus>
              <RoadmapPage />
            </Sus>
          }
        />
        <Route
          path="privacy"
          element={
            <Sus>
              <PrivacyPage />
            </Sus>
          }
        />
        <Route
          path="terms"
          element={
            <Sus>
              <TermsPage />
            </Sus>
          }
        />
        <Route
          path="dpa"
          element={
            <Sus>
              <DpaPage />
            </Sus>
          }
        />
        <Route
          path="security-policy"
          element={
            <Sus>
              <SecurityPolicyPage />
            </Sus>
          }
        />
        <Route
          path="login"
          element={
            <Sus>
              <LoginPage />
            </Sus>
          }
        />
        <Route
          path="signup"
          element={
            <Sus>
              <SignupPage />
            </Sus>
          }
        />
        <Route
          path="reset-password"
          element={
            <Sus>
              <ResetPasswordPage />
            </Sus>
          }
        />
        <Route
          path="search"
          element={
            <Sus>
              <SearchPage />
            </Sus>
          }
        />
        <Route
          path="books/:id"
          element={
            <Sus>
              <BookPage />
            </Sus>
          }
        />
        <Route
          path="lists/:id"
          element={
            <Sus>
              <ListPage />
            </Sus>
          }
        />
        <Route
          path="users/:username"
          element={
            <Sus>
              <UserProfilePage />
            </Sus>
          }
        />
        <Route
          path="settings"
          element={
            <Sus>
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            </Sus>
          }
        />
        <Route
          path="book-club"
          element={
            <Sus>
              <BookClubPage />
            </Sus>
          }
        />
        <Route
          path="share/:bookId"
          element={
            <Sus>
              <SharePage />
            </Sus>
          }
        />
        <Route
          path="admin"
          element={
            <Sus>
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            </Sus>
          }
        >
          <Route
            index
            element={
              <Sus>
                <AdminIndexPage />
              </Sus>
            }
          />
          <Route
            path="analytics"
            element={
              <Sus>
                <AdminAnalyticsPage />
              </Sus>
            }
          />
          <Route
            path="users"
            element={
              <Sus>
                <AdminUsersPage />
              </Sus>
            }
          />
          <Route
            path="messages"
            element={
              <Sus>
                <AdminMessagesPage />
              </Sus>
            }
          />
          <Route
            path="content"
            element={
              <Sus>
                <AdminContentPage />
              </Sus>
            }
          />
          <Route
            path="migration"
            element={
              <Sus>
                <AdminMigrationPage />
              </Sus>
            }
          />
        </Route>
        <Route
          path="*"
          element={
            <Sus>
              <NotFoundPage />
            </Sus>
          }
        />
      </Route>
    </Routes>
  );
}
